import { defineComponent as _defineComponent } from 'vue';
import FileUpload from 'primevue/fileupload';
import { ref } from 'vue';
import Button from 'primevue/button';
import { trans } from 'laravel-vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DocumentsForm',
    props: {
        newDocuments: {
            type: Array,
            default: [],
        },
        oldDocuments: {
            type: Array,
            default: [],
        },
        baseRoute: {
            type: String,
            required: true,
        },
        modelId: {
            type: Number,
            required: true,
        },
    },
    emits: ['update:newDocuments'],
    setup(__props, { expose, emit }) {
        const fileUpload = ref();
        const prepareDocuments = async (event) => {
            const files = event.files instanceof File ? [event.files] : event.files;
            emit('update:newDocuments', files);
        };
        const deleteDocument = (document) => (document.pending_delete = true);
        const undoDeleteDocument = (document) => (document.pending_delete = false);
        expose({
            upload() {
                fileUpload.value.upload();
            },
        });
        const __returned__ = { emit, fileUpload, prepareDocuments, deleteDocument, undoDeleteDocument, get FileUpload() { return FileUpload; }, get Button() { return Button; }, get trans() { return trans; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
